module.exports = __webpack_public_path__ + "ef844cfe84556bbd002f6eba46cb6854.pdf";